import React, {useMemo} from 'react';
import Page from "../../components/Page";
import InnerPage from "../../components/InnerPage";
import Container from "../../components/Container";
import Preloader from "../../components/Preloader";
import Error from "../404/Error";
import BG from './assets/bg_text.webp';
import { Helmet } from "react-helmet";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import { useTerms } from "../../api/api";
import { useTranslation } from "react-i18next";
import styles from './text-page.module.scss';

const Terms = () => {
  const [t, i18n] = useTranslation("global");
  const lang = useMemo(() => i18n.language.slice(0, 2), [i18n.language]);
  const { termsData, isTermsLoading, termsError } = useTerms(lang);

  if (isTermsLoading) {
    return <Preloader />
  }

  if (termsError || termsData.error) {
    return <Error />
  }

  const data = termsData.data;

  return (
    <Page>
      <Helmet>
        <title>RedBark Studio | {t("pages.terms")}</title>
      </Helmet>
      <InnerPage className={styles.wrapper} background={BG}>
        <Container>
          <div className="row flex-col-center-v">
            { data &&
              <div className="col-lg-8">
                <h1 className={styles.title}>{ data.title }</h1>
                <div className={styles.text}>
                  <BlocksRenderer content={data.content} />
                </div>
              </div>
            }
          </div>
        </Container>
      </InnerPage>
    </Page>
  );
};

export default Terms;